import SignupTherapistView from "./SignupTherapistView";

export const SignupTherapistContainer = () => {
  return (
    <div>
      <SignupTherapistView />
    </div>
  );
};
